export var FloorPlan;
(function (FloorPlan) {
    let type;
    (function (type) {
        type["FLOOR_PLAN"] = "FloorPlan";
    })(type = FloorPlan.type || (FloorPlan.type = {}));
})(FloorPlan || (FloorPlan = {}));
